import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ConfigLoader } from './config-loader';

import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

// Load config.json (so the application has it's config before it is bootstrapped).
const configLoader = new ConfigLoader();
configLoader.loadConfigDotJson(() => {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.log(err));
});
